import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import TabsDataState from "@sunSource/Store/Data/TabsData/TabsDataState";
import { Draft } from "immer";
import { NewsPageModel } from "@sunSource/Store/Data/TabsData/TabsDataState";

const initialState: TabsDataState = {
    activeTab: "",
    tabsSearchTerm: "",
    listActiveTabData: [],
    isLoading: false,
    tagsName: [],
    id: "",
    name: "",
    description: "",
    imageUrl: "",
    filteredData: {
        video: false,
        download: false,
        blog: false,
    }
};

const reducer = {
    "Custom/TabsDataState/loading": (
        draft: Draft<TabsDataState>,
        action: { isLoading: boolean },
    ) => {
        draft.isLoading = action.isLoading;
    },
    "Custom/TabsDataState/active": (
        draft: Draft<TabsDataState>,
        action: { activeTab: string },
    ) => {
        draft.activeTab = action.activeTab;
    },
    "Custom/TabsDataState/searchTerm": (
        draft: Draft<TabsDataState>,
        action: { tabsSearchTerm: string },
    ) => {
        draft.tabsSearchTerm = action.tabsSearchTerm;
    },
    "Custom/TabsDataState/tagsName": (
        draft: Draft<TabsDataState>,
        action: { tagsName: string },
    ) => {
        const tag = action.tagsName?.trim();

        if (!tag) {
            draft.tagsName = [];
            return;
        }

        if (tag.includes(",")) {
            const splitTagtoArray = tag.split(",");
            for (let i = 0; i < splitTagtoArray.length; i++) {
                console.log()
                if (!draft.tagsName.includes(splitTagtoArray[i])) {
                    draft.tagsName.push(splitTagtoArray[i]);
                }
            }
        } else {
            if (!draft.tagsName.includes(tag)) {
                draft.tagsName.push(tag);
            }
        }
    },
    "Custom/TabsDataState/removeSearchTerm": (
        draft: Draft<TabsDataState>,
        action: { tabsSearchTerm: string },
    ) => {
        draft.tabsSearchTerm = action.tabsSearchTerm;
    },
    "Custom/TabsDataState/removeTagName": (
        draft: Draft<TabsDataState>,
        action: { tagsName: string },
    ) => {
        const tag = action.tagsName?.trim();
        if (!tag) {
            draft.tagsName = [];
            return;
        }
        draft.tagsName = draft.tagsName.filter(tag => tag !== action.tagsName);
    },
    "Custom/TabsDataState/listActiveTab": (
        draft: Draft<TabsDataState>,
        action: { listActiveTabData: NewsPageModel[] },
    ) => {
        draft.listActiveTabData = action.listActiveTabData;
        draft.isLoading = false;
    },
      "Custom/TabsDataState/filter": (
        draft: Draft<TabsDataState>,
                action: { filterData: { video: boolean; download: boolean; blog: boolean } },
    ) => {
        draft.filteredData = action.filterData;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
